import BonusSaleReportPage from '../../../shared/reportBonusSale/BonusSaleReportPage'
import {ReportBonusSaleConfig} from '../../../shared/reportBonusSale/ReportBonusSaleConfig'

const config: ReportBonusSaleConfig = {
  reportsBaseUrl: '/api/reports',
  apiEndpoint: 'bonus-sale-items',
  exportEndpoint: 'bonus-sale-items/export',
  exportFileName: 'Relatorio_vendas_bonus_detalhado.xlsx',
  pageTitle: 'Relatório de Vendas Bonus Detalhado',
  breadcrumbPath: '/reports/reportBonusSaleDetail/list',
  navigationPath: '/reports/reportBonusSale/list',
  navigationPermission: 'reports.bonus_sales',
  navigationLabel: 'Resumido',
  navigationIcon: 'menu',
  isKpi: false,
  showFranchiseFilter: false,
  showClientAlertIcons: true,
  showPaymentsChart: false,
  useSwalErrorHandling: false,
  authPermission: 'reports.bonus_sale_items',
  exportPermission: 'reports.export',
  dateField: 'createdAt',
  reportType: 'detail',
}

const ReportBonusSaleDetailPage = () => <BonusSaleReportPage config={config} />

export default ReportBonusSaleDetailPage
